import { ILoanApplicationDetail } from '../../../../interface/LoanInterface';
import { formatDate } from '../../../../utils/dateTimeUtils';
import NoDataView from '../../../common/NoData';

const Repayments = ({ data, tabKey }: { data: ILoanApplicationDetail; tabKey: string }) => {
  return (
    <div className='table-responsive my-5'>
      {data.repayments.length > 0 && (
        <table className='table table-hover'>
          <thead>
            <tr>
              <th>Date</th>
              <th>Amount</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {data.repayments.map((repayment, key) => (
              <tr>
                <td>{formatDate(repayment.repaymentDate)}</td>
                <td>{repayment.amountPaid}</td>
                <td>{repayment.repaymentStatus}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
      {data.repayments.length === 0 && <NoDataView />}
    </div>
  );
};

export default Repayments;
